// Import package components
import { useContext, useEffect } from "react";
import {
  Switch,
  Route,
  useRouteMatch,
  useParams,
  Redirect,
} from "react-router-dom";

import { AppContexts } from "../../providers";

import AuthorizedRoute from "../../authorized-route";

import WorkOrderList from "./work_order_list";
import WorkOrderUpdate from "./work_order_update";

const WorkOrder = () => {
  const { path } = useRouteMatch();
  const { user } = useContext(AppContexts.AuthContext);

  const idRegEx = "[0-9]+";
  const uuidRexEx =
    "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}";

  return (
    <Switch>
      {user ? (
        <>
          <AuthorizedRoute exact path={path} component={WorkOrderList} />
          <AuthorizedRoute
            path={`${path}/:slug(${uuidRexEx})/:id(${idRegEx})`}
            component={WorkOrderUpdate}
          />
          <AuthorizedRoute
            exact
            path={`${path}/:slug(${uuidRexEx})`}
            component={WorkOrderList}
          />
          <AuthorizedRoute
            path={`${path}/:id(${idRegEx})`}
            component={WorkOrderUpdate}
          />
        </>
      ) : (
        <>
          <Route
            path={`${path}/:slug(${uuidRexEx})/:id(${idRegEx})`}
            component={WorkOrderUpdate}
          />
          <Route
            exact
            path={`${path}/:slug(${uuidRexEx})`}
            component={WorkOrderList}
          />
        </>
      )}
    </Switch>
  );
};

export default WorkOrder;
